import axios from "axios";

export const getCountryListApi = (payload) => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  return axios
    .get(`${baseURL}user-service/api/v1/${payload}/`)
    .then((res) => {
      //  console.log(res);
      return res;
    })
    .catch((err) => {
      return err;
    });
};
